export default "__VITE_ASSET__Cw84aA6m__"